import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { initialState, Material, TopicInfo } from './type'
import { getSubjects, getChapter } from './api'

export const userSlice = createSlice({
  name: 'subject',
  initialState,
  reducers: {
    resetChapters: (state) => {
      state.chapters = {}
    },
    setSelectedChapter: (state, action: PayloadAction<string>) => {
      state.chapters.selectedChapter = action?.payload
    },
    setSelectedTopic: (state, action: PayloadAction<TopicInfo>) => {
      state.chapters.selectedTopic = action?.payload
    },
    resetSelectedTopic: (state) => {
      state.chapters.selectedTopic = null
    },
    selectedMaterial: (state, action: PayloadAction<Material>) => {
      state.chapters.selectedMaterial = action?.payload
    },
    updateHasError: (state, action: PayloadAction<boolean>) => {
      state.hasError = action.payload
    }
  },
  extraReducers: {
    [getSubjects.pending.toString()]: (state) => {
      state.isLoading = true
    },
    [getSubjects.fulfilled.toString()]: (state, action) => {
      state.isLoading = false
      state.subjects = action?.payload?.subjects
      state.batchId = action?.payload?.batchId
    },
    [getSubjects.rejected.toString()]: (state) => {
      state.isLoading = false
      state.subjects = []
    },
    [getChapter.pending.toString()]: (state) => {
      state.chapters = {}
      state.isLoading = true
      state.hasError = false
    },
    [getChapter.fulfilled.toString()]: (state, action) => {
      state.isLoading = false
      state.chapters = action?.payload
    },
    [getChapter.rejected.toString()]: (state) => {
      state.isLoading = false
      state.chapters = {}
      state.hasError = true
    }
  }
})

export default userSlice.reducer
